<app-payment-panel-cmi-generic
  [payButtonText]="'payment.cmi.pay-with-cmi' | translate"
></app-payment-panel-cmi-generic>
